import { createContext, useState, useContext, useEffect } from "react";
import {jwtDecode} from "jwt-decode"; // nota: sin llaves

const RoleContext = createContext();

export const RoleProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  const decodeToken = (token) => {
    try {
      const decoded = jwtDecode(token);
      return decoded.role || null;
    } catch (error) {
      console.error("❌ Error al decodificar token:", error);
      return null;
    }
  };

  // // Función para revisar si un token JWT está expirado
  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);
      const now = Date.now() / 1000; // tiempo actual en segundos
      return decoded.exp < now;
    } catch (err) {
      return true; // token inválido cuenta como expirado
    }
  };

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    if (storedToken && !isTokenExpired(storedToken)) {
      setToken(storedToken);
      try {
        const decoded = jwtDecode(storedToken);
        setRole(decoded.role || null);
      } catch (err) {
        console.error("Error decodificando token:", err);
        setRole(null);
      }
    } else {
      // token inválido o expirado
      localStorage.removeItem("token");
      setToken(null);
      setRole(null);
    }
    setLoading(false); // ✅ fin de carga
  }, []);

  const login = (newToken) => {
    setToken(newToken);
    localStorage.setItem("token", newToken);
    const decodedRole = decodeToken(newToken);
    setRole(decodedRole);
  };

  // 🧩 Función para cerrar sesión
const logout = () => {
    setToken(null);
    setRole(null);
    localStorage.removeItem("token");
    localStorage.removeItem("nombreUsuario");
  };

  

  return (
    <RoleContext.Provider value={{ token, role, loading, login, logout }}>
      {children}
    </RoleContext.Provider>
  );
};

export const useRole = () => useContext(RoleContext);
